// features/employee/fund/components/EmployeeFundTable.jsx
import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Flex } from "antd";
import { useTranslation } from "react-i18next";
import TableAntdFix from "components/elements/Table/TableFixPage";
import styles from "../styles/EmployeeFund.module.css";

const initials = (nameTh) => (nameTh || "").trim().slice(0, 3).toUpperCase();

const formatRatePercent = (contribution) => {
    if (!contribution) return "-";
    if (contribution.method === "PERCENTAGE") {
        return `${contribution.rate ?? 0}% ของเงินเดือน`;
    }
    return `${(contribution.rate ?? 0).toLocaleString("th-TH")} บาท`;
};

const EmployeeFundTable = ({
    dataSource = [],
    isLoading = false,
    pagination = {},
    onChange = () => { },
    onView = () => { },
    onEdit = () => { },
    onDelete = () => { },
}) => {
    const { t } = useTranslation();

    const columns = [
        {
            title: t("fund.label.fundName") || "ชื่อกองทุน",
            dataIndex: "fundNameTh",
            key: "fundNameTh",
            render: (_, record) => (
                <Flex align="center" gap={12}>
                    {/* <div className={styles.fundAvatar}>{initials(record.fundNameTh)}</div> */}
                    <Flex vertical>
                        <span>{record.fundNameTh}</span>
                        <span className={styles.fundNameSub}>
                            {t("fund.label.fundType") || "ประเภท"}: {record.fundTypeLabel || record.fundNameEn}
                        </span>
                    </Flex>
                </Flex>
            ),
        },
        {
            title: t("fund.label.fundCode") || "เลขที่กองทุน",
            dataIndex: "fundCode",
            key: "fundCode",
        },
        {
            title: t("employeeFund.label.joinDate") || "วันที่เข้าร่วมกองทุน",
            dataIndex: "contractStartDate",
            key: "contractStartDate",
            render: (_, record) => (
                <Flex vertical>
                    <span>{record.contractStartDate}</span>
                    {record.membershipDurationLabel && (
                        <span className={styles.fundNameSub}>
                            {t("employeeFund.label.memberDuration") || "อายุสมาชิก"} {record.membershipDurationLabel}
                        </span>
                    )}
                </Flex>
            ),
        },
        {
            title: t("employeeFund.label.employeeAccumulatedRate") || "สะสมพนักงาน",
            dataIndex: ["employeeContribution", "rate"],
            key: "employeeContribution",
            render: (_, record) => formatRatePercent(record.employeeContribution),
        },
        {
            title: t("employeeFund.label.companyContributedRate") || "บริษัทสมทบ",
            dataIndex: ["companyContribution", "rate"],
            key: "companyContribution",
            render: (_, record) => formatRatePercent(record.companyContribution),
        },
        {
            title: t("employeeFund.label.fundStatus") || "สถานะ",
            dataIndex: "statusFlag",
            key: "statusFlag",
            render: (_, record) => {
                const isActive = (record.statusFlag ?? "ACTIVE") === "ACTIVE";
                return (
                    <Flex vertical>
                        <span>
                            <span
                                className={`${styles.statusDot} ${isActive ? styles.statusDotActive : styles.statusDotResigned}`}
                            />
                            {isActive
                                ? t("employeeFund.label.active") || "เป็นสมาชิก"
                                : t("employeeFund.label.resigned") || "ลาออก"}
                        </span>
                        {record.contributionEligibleSince && (
                            <span className={styles.statusSubText}>
                                {t("employeeFund.label.eligibleSince") || "ได้รับสิทธิสมทบแล้ว ตั้งแต่"}{" "}
                                {record.contributionEligibleSince}
                            </span>
                        )}
                    </Flex>
                );
            },
        },
        {
            title: t("employeeFund.label.actions") || "จัดการ",
            key: "actions",
            align: "center",
            render: (_, record) => (
                <Flex align="center" justify="center" gap={8}>
                    {/* <Button onClick={() => onView(record)}>{t("employeeFund.label.viewDetail") || "ดูรายละเอียด"}</Button> */}
                    <Dropdown
                        menu={{
                            items: [
                                { key: "view", label: t("employeeFund.label.viewDetail") || "ดูรายละเอียด" },
                                { key: "edit", label: t("common.edit") || "แก้ไข" },
                                { key: "delete", label: t("common.delete") || "ลบ", danger: true },
                            ],
                            onClick: ({ key }) => {
                                if (key === "view") onView(record);
                                if (key === "edit") onEdit(record);
                                if (key === "delete") onDelete(record);
                            },
                        }}
                        trigger={["click"]}
                    >
                        <MoreOutlined />
                    </Dropdown>
                </Flex>
            ),
        },
    ];

    return (
        <div className={styles.tableCard}>
            <TableAntdFix
                loading={isLoading}
                pagination={pagination}
                dataSource={dataSource}
                columns={columns}
                rowKey={(record) => record.id}
                onChange={onChange}
            />
        </div>
    );
};

export default EmployeeFundTable;
